import Dialog from "src/components/Dialog";
import { useTranslation } from "react-i18next";

export default function BabyStoppedSeeMeDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("parentStation.babyStoppedSeeMe.heading")}
      text={t("parentStation.babyStoppedSeeMe.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
